export default "__VITE_ASSET__BvUU2isJ__"